<template>
  <div class="add-to-group-modal">
    <AppModal :bottom-sheet="false"
              :close-on-overlay="!isMobile"
              :max-height="isMobile ? '100%' : '90vh'"
              :show-close-button="true"
              :title="modalTitle"
              :visible.sync="isOpen"
              :width="isMobile ? '100%' : '75%'"
              @close="onAppModalClose"
    >
      <div class="add-to-group-body">
        <div class="card mb-0 add-to-group-dialog">
          <div class="card-header actions-toolbar border-0 add-to-group-toolbar">
            <div class="add-to-group-controls">
              <div class="add-to-group-search">
                <div class="uk-search uk-search-navbar add-to-group-search-field">
                  <span class="uk-search-icon add-to-group-search-icon">
                    <i class="uil-search"></i>
                  </span>
                  <input v-model="filter.search" :placeholder="$t('general.search')" class="uk-search-input shadow-0 uk-form-small"
                         type="search"/>
                </div>
              </div>

              <div class="d-flex add-to-group-topbar add-to-group-topbar-left">
                <button class="btn btn-sm btn-soft-secondary add-to-group-select-all" type="button" @click="toggleVisibleUsers(type)">
                  <i class="uil-check-square"></i> {{ selectAllText }}
                </button>
                <span v-if="allowed_number" class="btn ml-2 btn-sm bg-section-secondary text-muted add-to-group-max">{{ $t('general.maximum') }}({{
                    allowed_number
                  }})</span>
              </div>
              <div class="d-flex add-to-group-toolbar-actions">
                <!-- Shorting -->
                <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false"
                   class="btn btn-icon btn-hover btn-circle" href="javascript:void(0)" title="">
                  <i class="uil-list-ui-alt"></i>
                </a>
                <div ref="filterRef" class="uk-dropdown add-to-group-sort-dropdown"
                     uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li class="uk-active">
                      <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("filters.order.a_z") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("filters.order.z_a") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('asc', 'created_at')">
                        {{ $t("filters.order.created_at_asc") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('desc', 'created_at')">
                        {{ $t("filters.order.created_at_desc") }}</a>
                    </li>
                  </ul>
                </div>
                <!-- Filter -->
                <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover  btn-circle"
                   href="javascript:void(0)">
                  <i class="uil-filter"></i>
                </a>
                <UserFilter id="userFilterModal" nested :has-status="has_user_status" :isDate="false"
                            @getFilter="getFilter($event)"></UserFilter>
              </div>
              <div class="d-flex add-to-group-topbar-right">
                <multiple-select-input v-model="selectedPerPage"
                                       :allow-empty="false"
                                       :control-height="48"
                                       :min-width="96"
                                       :multiple="false"
                                       :searchable="false"
                                       :show-labels="false"
                                       :values="perPageOptions"
                                       class="add-to-group-per-page"
                />
              </div>
            </div>
          </div>
          <!-- Table -->
          <div class="table-responsive add-to-group-table-wrap">
            <table class="table align-items-center add-to-group-table">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ this.$t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ this.$t('general.title_position') }}</th>
                <th scope="col">{{ $t("general.corporation") }}</th>
                <th scope="col">{{ this.$t('general.added_at') }}</th>
                <th scope="col">{{ this.$t('users.last_login_date') }}</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="item in formattedItem" :key="item.id">
                <th class="add-to-group-col-check" scope="row">
                  <label :for="'checkbox_' + item.id" class="add-to-group-check">
                    <input v-if="!existing_users.includes(item.id)" :id="'checkbox_' + item.id"
                           :checked="selectedUsers.some(r => r.id === item.id)" type="checkbox"
                           @change="addUser($event, item)"/>
                    <input v-else :checked="true" class="disabled" disabled type="checkbox"/>
                  </label>
                </th>

                <th class="add-to-group-col-name" scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child" style="width: max-content">
                        <img :src="item.photo_link" alt="Image placeholder" class="avatar rounded-circle"/>
                        <span :class="item.is_online ? 'bg-success' : 'bg-offline'
                              " class="avatar-child avatar-badge"></span>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                      <a class="name h6 mb-0 text-sm" @click="setActiveItem(item)">{{ item.fullname }}</a>
                      <small class="d-block font-weight-bold">#{{ item.id }}</small>
                    </div>
                  </div>
                </th>
                <td class="add-to-group-col-field">{{ item.title }}</td>
                <td class="add-to-group-col-field">{{ item.corporateName }}</td>
                <td class="add-to-group-col-field">{{ item.created_at }}</td>
                <td class="add-to-group-col-field">{{ item.last_login_at }}</td>
                <td class="text-right add-to-group-col-actions">
                  <div class="actions ml-3 add-to-group-row-actions">
                    <a class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.user_profil')"
                       @click="setActiveItem(item)">
                      <i class="uil-user"></i>
                    </a>
                  </div>
                </td>
              </tr>
              <!--user item-->
              </tbody>
            </table>
          </div>
        </div>
        <pagination :pagination="pagination" class="mt-3 add-to-group-pagination" @changePage="setPage($event)"></pagination>
      </div>

      <template #footer>
        <div class="add-to-group-footer">
          <button class="uk-button uk-button-outline-default mr-2 small closeButton add-to-group-back-btn" type="button"
                  @click="cancelSelection">
            <i class="icon-arrow-left"></i> {{ $t('general.back') }}
          </button>
          <button class="uk-button uk-button-primary small closeButton add-to-group-save-btn" type="button" @click="setSelectedUser">
            <i class="icon-feather-save"></i> {{ $t("general.save") }}
          </button>
        </div>
      </template>
    </AppModal>
    <UserProfile
        v-if="activeItem"
        :item="activeItem"
        :user_detail="formattedUserDetail"
        @modalClosed="activeItem = null"
    ></UserProfile>
  </div>
</template>

<script>
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
  ERROR,
  ITEMS,
} from "@/core/services/store/user.module";

import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";
import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";

import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import UserFilter from "@/view/company/User/Filter";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import AppModal from "@/view/components/ui/AppModal.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _USER_DETAIL_MODULE = USER_DETAIL_MODULE;
const _USER_MODULE = MODULE_NAME;
const _COMPANY_MODULE = COMPANY_MODULE;

export default {
  name: "AddToGroupModal",
  components: { Pagination, UserFilter, UserProfile, AppModal, MultipleSelectInput },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      required: false,
      default: "",
    },
    allowed_number: {
      required: false,
      type: Number,
      default: 0,
    },
    has_user_status: {
      type: Boolean,
      default: false,
    },
    existing_users: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
    selected_users: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      pagination: null,
      activeItem: null,
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        orderBy: "desc",
        sort: "id",
      },
      selectedUsers: [],
      type: true,
      selectAllText: this.$t('general.select_all'),
      keepFilter: null,
      isMobile: false,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_USER_MODULE, module);
    registerStoreModule(_COMPANY_MODULE, company_module);
    registerStoreModule(_USER_DETAIL_MODULE, user_detail_module);
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    modalTitle() {
      const base = this.title ? this.title : this.$t("user_group.add_user_group");
      return `${base} (${this.selectedUsers.length})`;
    },
    user_detail: {
      get() {
        return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
      },
      set(value) {
      },
    },
    formattedUserDetail() {
      if (this.user_detail === null) return null;
      return this.user_detail;
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    items: {
      get() {
        return store.getters[_USER_MODULE + "/" + ITEMS];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    perPageOptions() {
      return [10, 50, 100, 500, 1000].map((value) => ({
        id: value,
        name: String(value),
      }));
    },
    selectedPerPage: {
      get() {
        return this.perPageOptions.find((option) => option.id === Number(this.per_page))
            || this.perPageOptions[0];
      },
      set(value) {
        const nextPerPage = value && value.id ? Number(value.id) : 10;
        if (Number(this.per_page) === nextPerPage) {
          return;
        }
        this.per_page = nextPerPage;
        this.filterResult();
      },
    },
    formattedItem() {
      if (this.items === null || !("data" in this.items)) return [];
      let results = [];
      this.pagination = this.items;
      const onlineUsers = Array.isArray(this.onlineUsers) ? this.onlineUsers : [];
      this.items.data.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          phone: item.phone,
          photo_link: item.photo_link,
          is_online: !!onlineUsers.find(
              (onlineUser) => onlineUser.user == item.id && onlineUser.status
          ),
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          corporateName: item.corporate?.name || "-",
          created_at: item.created_at
              ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: item.last_login_at
              ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });

      return results;
    },
  },
  methods: {
    cloneUsers(users = []) {
      return Array.isArray(users) ? users.map((user) => ({ ...user })) : [];
    },
    syncSelectedUsersFromProps() {
      this.selectedUsers = this.cloneUsers(this.selected_users);
      this.selectAllText = this.$t('general.select_all');
      this.type = true;
    },
    closeGroupModal() {
      this.isOpen = false;
    },
    onAppModalClose() {
      this.syncSelectedUsersFromProps();
      this.closeGroupModal();
    },
    updateIsMobile() {
      this.isMobile = typeof window !== "undefined" && window.innerWidth <= 959;
    },
    getUserDetail(id) {
      store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail-admin" + "/" + id,
      });
    },
    setActiveItem(item) {
      this.activeItem = item;
      UIkit.modal("#modal-profile").show();
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
    // aktif filtreden (keepFilter) tek noktada istek parametreleri üretilir
    buildRequestFilters() {
      const activeFilter = this.keepFilter || {};

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        order: this.filter.orderBy,
        sort: this.filter.sort,
      };

      if (this.has_user_status) {
        // aktif-pasif kullanıcı durumu
        if (activeFilter.user_status === 1) {
          filters['status'] = true;
        } else if (activeFilter.user_status === 0) {
          filters['status'] = false;
        } else {
          filters['status'] = null;
        }
      }

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!value || !Array.isArray(value) || key === 'company_id') return;

        let ids = value.map((item) => item.id);

        // "Tümü" seçiliyse (id null) assignment_id gönderilmez
        if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
          ids = null;
        }

        filters[key] = JSON.stringify(ids);
      });

      return filters;
    },
    filterResult(filter = null) {
      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, arama)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = { ...filter };
      }

      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: this.buildRequestFilters(),
      }).then((response) => {
        if (!response || !Array.isArray(response.data)) return;
        response.data.forEach((responseData) => {
          let flag = true;
          this.selectedUsers.forEach((selectedUsers) => {
            if (responseData.id === selectedUsers.id) {
              flag = false;
            }
          })
          if (flag) {
            this.selectAllText = this.$t('general.select_all');
            this.type = true;
          }
        })
      });
    },
    addUser(eve, user) {
      let users = this.selectedUsers;
      let index = users
          .map((u) => {
            return u.id;
          })
          .indexOf(user.id);

      if (index === -1) {
        if (this.allowed_number == 0 || users.length < this.allowed_number)
          users.push(user);
        else eve.target.checked = false;
      } else users.splice(index, 1);
    },
    sortOrder(orderBy, sort) {
      this.page = 1;
      this.filter.orderBy = orderBy;
      this.filter.sort = sort;
      this.filterResult();
      UIkit.dropdown(this.$refs["filterRef"]).hide(0);
    },
    setPage(page) {
      this.page = page;
      // Yeni filtre gönderme; keepFilter'daki son filtreyle sadece sayfa değişsin
      this.filterResult();
    },
    toggleVisibleUsers(val) {
      if (val) {
        const selectedIds = this.selectedUsers.map((user) => user.id);
        this.formattedItem.forEach((item) => {
          if (
              (this.allowed_number != 0 &&
                  this.selectedUsers.length >= this.allowed_number) ||
              this.existing_users.includes(item.id) ||
              selectedIds.includes(item.id)
          ) {
            return;
          }
          this.addUser(null, item);
        });
        this.selectAllText = this.$t('general.deselect_all');
        this.type = false;
        return;
      }

      const currentPageIds = this.formattedItem.map((item) => item.id);
      this.selectedUsers = this.selectedUsers.filter(
          (user) => !currentPageIds.includes(user.id)
      );
      this.selectAllText = this.$t('general.deselect_all');
      this.type = true;
    },
    allToggle(val) {
      if (val) {
        this.formattedItem.forEach((item) => {
          if (
              (this.allowed_number != 0 &&
                  this.selectedUsers.length >= this.allowed_number) ||
              this.existing_users.includes(item.id)
          )
            return false;
          this.addUser(null, item);
          $("#checkbox_" + item.id).prop("checked", true);
          this.selectAllText = this.$t('general.deselect_all');
          this.type = false;
        });
      } else {
        this.formattedItem.forEach((item) => {
          $("#checkbox_" + item.id).prop("checked", false);
          this.selectedUsers.forEach((data, index) => {
            if (data.id === item.id) {
              this.selectedUsers.splice(index, 1);
            }
          })
        });

        // this.selectedUsers = [];
        this.selectAllText = this.$t('general.select_all');
        this.type = true;
      }
    },
    setSelectedUser() {
      const selectedUsers = this.cloneUsers(this.selectedUsers);
      this.$emit("getList", selectedUsers);
      this.closeGroupModal();
    },
    cancelSelection() {
      this.syncSelectedUsersFromProps();
      this.closeGroupModal();
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin kullanıcıları gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
    this.debouncedFilterSearch = _.debounce(() => this.filterResult(), 500);
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile, { passive: true });
    this.syncSelectedUsersFromProps();
  },
  watch: {
    "filter.search"() {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    isOpen(val) {
      if (val) {
        this.syncSelectedUsersFromProps();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsMobile);

    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
};
</script>

<style scoped>
.add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) {
  z-index: 1100;
}

.add-to-group-modal ::v-deep .app-modal-overlay--nested {
  z-index: 1200;
}

.add-to-group-modal ::v-deep #modal-profile {
  z-index: 1300;
}

.add-to-group-modal ::v-deep .app-modal-body {
  padding: 16px;
}

.add-to-group-modal ::v-deep .app-modal-footer {
  width: 100%;
  padding: 16px;
}

.add-to-group-modal ::v-deep .app-modal-close {
  min-width: 44px;
  min-height: 44px;
}

.add-to-group-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "selectall perpage"
    "search actions";
  gap: 8px 16px;
  align-items: center;
}

.add-to-group-search {
  grid-area: search;
  min-width: 0;
  width: 100%;
}

.add-to-group-search-field,
.add-to-group-search-field.uk-search-navbar {
  display: block;
  position: relative;
  width: 100%;
  max-width: 100%;
}

.add-to-group-search-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  pointer-events: none;
  color: #3f87f5;
  font-size: 20px;
  line-height: 1;
}

.add-to-group-search .uk-search-input {
  box-sizing: border-box;
  width: 100%;
  padding-left: 40px;
}

.add-to-group-topbar-left,
.add-to-group-topbar-right,
.add-to-group-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-to-group-topbar-left {
  grid-area: selectall;
}

.add-to-group-toolbar {
  overflow: visible;
}

.add-to-group-toolbar-actions {
  grid-area: actions;
  position: relative;
}

.add-to-group-topbar-right {
  grid-area: perpage;
  justify-content: flex-end;
}

.add-to-group-per-page {
  flex: 0 0 auto;
  width: 96px;
  max-width: 96px;
  margin: 0 !important;
}

.add-to-group-modal ::v-deep .add-to-group-per-page.form-group {
  margin-bottom: 0;
}

.add-to-group-modal ::v-deep .add-to-group-per-page .multiselect {
  min-width: 0;
  width: 96px;
  max-width: 96px;
}

.add-to-group-modal ::v-deep .add-to-group-per-page .multiselect--active {
  z-index: 20;
}

.add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__content-wrapper {
  min-width: 96px;
  width: 96px;
  max-width: 96px;
}

.add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__input {
  display: none !important;
}

.add-to-group-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.add-to-group-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.add-to-group-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.add-to-group-back-btn,
.add-to-group-save-btn {
  box-sizing: border-box;
  padding: 10px 17px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  line-height: 17px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.add-to-group-back-btn:active,
.add-to-group-save-btn:active,
.add-to-group-select-all:active,
.add-to-group-row-actions .btn-circle:active {
  transform: scale(0.98);
  opacity: 0.85;
}

.add-to-group-row-actions .btn-circle,
.add-to-group-toolbar-actions .btn-circle {
  width: 30px;
  height: 30px;
}

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}

@media (max-width: 959px) {
  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal {
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    min-height: 100%;
    max-height: 100% !important;
    border-radius: 0;
    box-shadow: none;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-header {
    padding: 16px;
    border-radius: 0;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-title {
    font-size: 16px;
    line-height: 1.4;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-close {
    min-width: 48px;
    min-height: 48px;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-body {
    flex: 1;
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .add-to-group-modal ::v-deep .app-modal-overlay:not(.app-modal-overlay--nested) .app-modal-footer {
    padding: 16px;
  }

  .add-to-group-check {
    min-width: 48px;
    min-height: 48px;
  }

  .add-to-group-row-actions .btn-circle,
  .add-to-group-toolbar-actions .btn-circle {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .add-to-group-back-btn,
  .add-to-group-save-btn {
    min-height: 48px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
  }

  .add-to-group-table {
    min-width: 800px;
  }

  .add-to-group-table th,
  .add-to-group-table td {
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
  }

  .add-to-group-controls {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .add-to-group-search {
    flex: 1 0 100%;
    width: 100%;
    order: 1;
  }

  .add-to-group-search-icon {
    width: 48px;
  }

  .add-to-group-search .uk-search-input {
    height: 48px;
    min-height: 48px;
    padding: 12px 16px 12px 48px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    background: #fff;
    font-size: 16px;
    line-height: 1.4;
  }

  .add-to-group-search,
  .add-to-group-topbar-left,
  .add-to-group-topbar-right,
  .add-to-group-toolbar-actions {
    grid-area: auto;
  }

  .add-to-group-topbar-left,
  .add-to-group-topbar-right,
  .add-to-group-toolbar-actions {
    float: none;
    width: auto;
    flex: 0 0 auto;
  }

  .add-to-group-topbar-left {
    order: 2;
  }

  .add-to-group-toolbar-actions {
    order: 3;
    justify-content: flex-start;
  }

  .add-to-group-topbar-right {
    order: 4;
  }

  .add-to-group-select-all,
  .add-to-group-max {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 12px 16px;
    margin: 0;
    border-radius: 10px;
    font-size: 16px;
    touch-action: manipulation;
  }

  .add-to-group-per-page {
    margin-left: 0 !important;
    width: 96px !important;
    max-width: 96px;
  }

  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect,
  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__tags,
  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__select {
    height: 48px !important;
    min-height: 48px;
    border-radius: 10px;
  }

  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__single,
  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__placeholder {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
  }

  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__option {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
  }

  .add-to-group-modal ::v-deep .add-to-group-per-page .multiselect__content-wrapper {
    min-width: 96px;
    max-width: 96px;
    max-height: 240px !important;
  }

  .add-to-group-sort-dropdown {
    box-sizing: border-box;
    width: max-content;
    min-width: 180px;
    max-width: 220px;
    padding: 8px;
  }

  .add-to-group-sort-dropdown .uk-dropdown-nav {
    white-space: normal;
  }

  .add-to-group-sort-dropdown .uk-dropdown-nav > li > a {
    display: flex;
    align-items: center;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 1.4;
    white-space: normal;
  }
}

@media (max-width: 767px) {
  .add-to-group-footer {
    flex-direction: row;
    align-items: stretch;
  }

  .add-to-group-back-btn,
  .add-to-group-save-btn {
    flex: 1 1 0;
    width: auto;
    margin: 0 !important;
  }
}

@media (hover: hover) and (pointer: fine) {
  .add-to-group-back-btn,
  .add-to-group-save-btn,
  .add-to-group-select-all {
    cursor: pointer;
  }
}

@media (hover: none) {
  .add-to-group-modal ::v-deep .btn-hover:hover,
  .add-to-group-modal ::v-deep .app-modal-close:hover {
    background-color: transparent;
    color: #666;
  }
}

@media (prefers-reduced-motion: reduce) {
  .add-to-group-back-btn:active,
  .add-to-group-save-btn:active,
  .add-to-group-select-all:active,
  .add-to-group-row-actions .btn-circle:active {
    transform: none;
  }
}
</style>
